import React, { useState } from 'react';
import '../Assets/css/Contact.css';
// import '../Components/backend/server'
const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   console.log('Form submitted:', formData);
  //   alert("Thanks for contacting us!");
  //   setFormData({ name: '', email: '', subject: '', message: '' });
  // };


  const handleSubmit = async (e) => {
    e.preventDefault();
  
    try {
      const res = await fetch('http://localhost:5000/send-email', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });
  
      const result = await res.json();
  
      if (result.success) {
        alert('Thanks for contacting us!');
        setFormData({ name: '', email: '', subject: '', message: '' });
      } else {
        alert('Failed to send email. Please try again later.');
      }
    } catch (error) {
      console.error('Error:', error);
      alert('Something went wrong. Try again.');
    }
  };
  






  return (
    <div className="contacts-container">
      <h2 style={{color:'whitesmoke'}}>Contact Us</h2>
      <form onSubmit={handleSubmit} className="contact-form">
        <input type="text" name="name" placeholder="Your Name" value={formData.name} onChange={handleChange} required />
        <input type="email" name="email" placeholder="Your Email" value={formData.email} onChange={handleChange} required />
        <input type="text" name="subject" placeholder="Subject" value={formData.subject} onChange={handleChange} required />
        <textarea name="message" placeholder="Your Message" value={formData.message} onChange={handleChange} required />
        <button type="submit">Submit</button>
      </form>

      {/* Embed Google Maps Directly */}
 

<style>{`
  @media (max-width: 768px) {
    .contacts-container {
      padding: 20px;
    }

    .contacts-container h2 {
      font-size: 24px;
      text-align: center;
    }

    .contact-form {
      display: flex;
      flex-direction: column;
      gap: 15px;
      width: 100%;
    }

    .contact-form input,
    .contact-form textarea {
      width: 100% !important;
      font-size: 16px;
      padding: 12px;
    }

    .contact-form textarea {
      height: 120px;
    }

    .contact-form button {
      padding: 12px;
      font-size: 16px;
      background-color: rgb(255, 215, 0);
      color: #fff;
      border: none;
      cursor: pointer;
    }

    .contact-form button:hover {
      background-color: #ffffffff;
      color: black;
    }
  }
`}</style>


    </div>
  );
};

export default Contact;
